/** @format */

import React from 'react';
import {
  outboundLinkChecker,
  internalLinkFormatter,
  localeUrlCheck,
} from '@services/url-services';
import Translate from '@components/translation/translate-text-wrapper';

/**
 * Link Props.
 */
interface LinkProps {
  classes?: string;
  linkText: string;
  url: string;
  openNewWindow?: boolean;
}

/**
 * Link Button
 * @param props
 */
const Link = (props: LinkProps) => {
  const { url, classes, linkText, openNewWindow = false } = props;
  if (outboundLinkChecker(url) || openNewWindow) {
    return (
      <a className={classes} href={url} target="_blank" rel="noopener">
        <Translate>{linkText}</Translate>
      </a>
    );
  }

  const safeLocalizedUrl = localeUrlCheck(internalLinkFormatter(url));
  return (
    <a className={classes} href={safeLocalizedUrl}>
      <Translate>{linkText}</Translate>
    </a>
  );
};
export default Link;
